export default "__VITE_ASSET__BT$0wJ7t__"